
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seja-um-profissional/[category]/[...service]",
      function () {
        return require("private-next-pages/seja-um-profissional/[category]/[...service].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seja-um-profissional/[category]/[...service]"])
      });
    }
  